import { render, staticRenderFns } from "./BtnCopyProduct.vue?vue&type=template&id=c68041a4"
import script from "./BtnCopyProduct.vue?vue&type=script&lang=js"
export * from "./BtnCopyProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports